module.exports = __webpack_public_path__ + "static/media/b8.b029a715.png";